import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@app/_guards';
import { NonInfluencerGuard } from '@app/_guards/non-influencer.guard';
import { ProjectAddComponent } from './project-add';
import { ProjectListComponent } from './project-list';
import { AddInfluencerComponent } from './add-influencer';
import { InfluencerAddComponent } from '@app/modules/influencer/influencer-add';
import { ShareProjectComponent } from './share-project';
import {WidgetInstructionsComponent} from '@app/modules/project/widget-instrcutions/widget-instructions.component';
import {ThirdpartyPlatformsComponent} from './thirdparty-platforms-view';
import {InfluencerAutoJoinComponent} from './influencer-auto-join-view';
import { DragDropModule } from '@angular/cdk/drag-drop';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: ProjectListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'projects/create',
        component: ProjectAddComponent,
        canActivate: [AuthGuard, NonInfluencerGuard]
      },
      {
        path: 'projects/:projectId/influencer-auto-join',
        component: InfluencerAutoJoinComponent,
        canActivate: [AuthGuard, NonInfluencerGuard]
      },
      {
        path: 'projects/:projectId/edit',
        component: ProjectAddComponent,
        canActivate: [AuthGuard, NonInfluencerGuard],
        data: {navTitle: 'Project settings'}
      },
      {
        // The old inline edit page (ProjectViewComponent) has been merged into
        // ProjectAddComponent; keep deep links to /projects/:id working.
        path: 'projects/:id',
        redirectTo: 'projects/:id/edit'
      },
      {
        path: 'project/:id/add-influencer',
        component: AddInfluencerComponent,
        canActivate: [AuthGuard, NonInfluencerGuard],
        data: {navParent: 'project.influencers', navTitle: 'Add influencers'}
      },
      {
        path: 'project/:projectId/influencer/add',
        component: InfluencerAddComponent,
        canActivate: [AuthGuard, NonInfluencerGuard],
        data: {navParent: 'project.influencers', navTitle: 'New influencer'}
      },
      {
        path: 'project/:projectId/influencer/edit/:influencerId',
        component: InfluencerAddComponent,
        canActivate: [AuthGuard, NonInfluencerGuard],
        data: {navParent: 'project.influencers', navTitle: 'Edit influencer'}
      },
      {
        path: 'projects/:projectId/share',
        component: ShareProjectComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'projects/:projectId/widget',
        component: WidgetInstructionsComponent,
        canActivate: [AuthGuard, NonInfluencerGuard]
      },
      {
        path: 'projects/:projectId/registration-platforms',
        component: ThirdpartyPlatformsComponent,
        canActivate: [AuthGuard, NonInfluencerGuard]
      }
    ]
  }
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes), DragDropModule],
  exports: [RouterModule]
})
export class ProjectRoutingModule { }
